import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import "./styles/global.css";

import Home from "./pages/Home";
import Loans from "./pages/Loans";
import Education from "./pages/Education";
import Travel from "./pages/Travel";
import Goldplus from "./pages/Goldplus";
import OurTeam from "./pages/OurTeam";
import StaffPortal from "./pages/StaffPortal";

import LoadingScreen from "./components/LoadingScreen";
import { AnimatePresence } from "framer-motion";

export default function App() {
  const [loading, setLoading] = React.useState(true);

  return (
    <>
      <AnimatePresence>
        {loading && <LoadingScreen onComplete={() => setLoading(false)} />}
      </AnimatePresence>

      {!loading && (
        <>
          <Navbar />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/loans" element={<Loans />} />
            <Route path="/education-support" element={<Education />} />
            <Route path="/travel-transport" element={<Travel />} />
            <Route path="/gold-plus" element={<Goldplus />} />
            <Route path="/our-team" element={<OurTeam />} />
            <Route path="/staff-portal" element={<StaffPortal />} />
          </Routes>

          <Footer />
        </>
      )}
    </>
  );
}
